import { useTranslation, Trans } from "react-i18next";

import sss1 from '../../img/Home/sss1.svg'
import sss2 from '../../img/Home/sss2.svg'
import sss3 from '../../img/Home/sss3.svg'
import sss4 from '../../img/Home/sss4.svg'

function Brockerage() {

  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden mt-[80px] xl:mt-[140px]">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col">
            <p className="text-[#061A77] font-[500] leading-[1.2] poppins text-[28px] xl:text-[48px] mx-auto">{t('home.21')}</p>
            <div className="grid grid-cols-2 xl:grid-cols-4 mt-[30px] xl:mt-[60px] gap-[50px]">
                <div className="flex flex-col items-center">
                    <img src={sss1} alt="" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]"/>
                    <p className="text-[#061A77] mt-[20px] xl:mt-[30px] font-[500] leading-[1.2] poppins text-[24px] xl:text-[32px] mx-auto">{t('home.22')}</p>
                    <p className="mt-[10px] xl:mt-[6px] text-[#000000B2] text-[14px] inter text-center">{t('home.23')}</p> 
                </div>
                <div className="flex flex-col items-center">
                    <img src={sss2} alt="" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]"/>
                    <p className="text-[#061A77] mt-[20px] xl:mt-[30px] font-[500] leading-[1.2] poppins text-[24px] xl:text-[32px] mx-auto">{t('home.24')}</p>
                    <p className="mt-[10px] xl:mt-[6px] text-[#000000B2] text-[14px] inter text-center">{t('home.25')}</p> 
                </div>
                <div className="flex flex-col items-center">
                    <img src={sss3} alt="" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]"/>
                    <p className="text-[#061A77] mt-[20px] xl:mt-[30px] font-[500] leading-[1.2] poppins text-[24px] xl:text-[32px] mx-auto">{t('home.26')}</p>
                    <p className="mt-[10px] xl:mt-[6px] text-[#000000B2] text-[14px] inter text-center">{t('home.27')}</p> 
                </div>
                <div className="flex flex-col items-center">
                    <img src={sss4} alt="" className="w-[40px] h-[40px] xl:w-[60px] xl:h-[60px]"/>
                    <p className="text-[#061A77] mt-[20px] xl:mt-[30px] font-[500] leading-[1.2] poppins text-[24px] xl:text-[32px] mx-auto">{t('home.28')}</p>
                    <p className="mt-[10px] xl:mt-[6px] text-[#000000B2] text-[14px] inter text-center">{t('home.29')}</p> 
                </div>
            </div>
        </div>
    </div>
  );
}

export default Brockerage;
 